// extracted by mini-css-extract-plugin
export default {"main-image":"mainImage_main-image__h7XgX"};